var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 16.5,
    viewBox: "0 0 12.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(0.25 4.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M.375,29.7a.406.406,0,0,1,.375.432V32.29a.813.813,0,0,0,.75.863h9a.813.813,0,0,0,.75-.863V30.132a.379.379,0,1,1,.75,0V32.29a1.625,1.625,0,0,1-1.5,1.727h-9A1.625,1.625,0,0,1,0,32.29V30.132A.406.406,0,0,1,.375,29.7Z",
    transform: "translate(0 -22.016)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M16.251,3.124a.442.442,0,0,1,.62,0L19.5,5.714a.428.428,0,0,1,0,.611.442.442,0,0,1-.62,0L17,4.472v7.591a.438.438,0,0,1-.875,0V4.472L14.246,6.325a.442.442,0,0,1-.62,0,.428.428,0,0,1,0-.611Z",
    transform: "translate(22.561 8.494) rotate(180)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file-download.25bec07a83a58f87a436a311b3798fcd.svg";
export { ForwardRef as ReactComponent };